import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';

// Sample data (Replace with your actual data source)
const sampleItems = [
    { id: 1, name: 'Blog Post 1', category: 'blog', icon: '📚' },
    { id: 2, name: 'Challenge 1', category: 'challenge', icon: '🏆' },
    { id: 3, name: 'Blog Post 2', category: 'blog', icon: '📖' },
    { id: 4, name: 'Challenge 2', category: 'challenge', icon: '🎯' },
    // Add more items as needed
];

const MasterSearch = ({className}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredItems, setFilteredItems] = useState([]);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredItems([]);
            return;
        }

        const results = sampleItems.filter(item =>
            item.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredItems(results);
    }, [searchTerm]);

    return (
        <div className="relative">
            <div className={`flex items-center transition border-2 rounded-md overflow-hidden ${isFocused ? 'border-gray-700' : 'border-gray-200'} ${className}`}>
                <input
                    type="text"
                    placeholder="جستجو..."
                    value={searchTerm}
                    onFocus={() => setIsFocused(true)}
                    onfocusout={() => setIsFocused(false)}
                    onChange={(e) => {setSearchTerm(e.target.value)}}
                    className="p-2 m-2 w-full rounded-md bg-transparent border-0 outline-0"
                />
                <span className='bg-gray-200 w-10 h-10 flex items-center justify-center m-2 transition hover:bg-gray-300 rounded-md cursor-pointer'>
                <FontAwesomeIcon icon={faSearch} className="text-gray-500" />
                </span>
            </div>
            {filteredItems.length > 0 && (
                <div className="absolute top-full left-0 mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-10">
                    <div className="p-2">
                        {filteredItems.map(item => (
                            <div key={item.id} className="flex items-center p-2 hover:bg-gray-100 cursor-pointer">
                                <span className="text-2xl mr-2">{item.icon}</span>
                                <span className="text-gray-800">{item.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {searchTerm && (
                <button
                    onClick={() => setSearchTerm('')}
                    className="absolute top-1 right-1 p-1 text-gray-500 hover:text-gray-800"
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            )}
        </div>
    );
};

export default MasterSearch;
